export function anchorScroll() {
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  anchorLinks.forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
          const href = anchor.getAttribute('href');
          const hashIndex = href.indexOf('#');
          const targetId = href.substring(hashIndex);

          if (window.location.href.split('#')[0] === anchor.href.split('#')[0]) {
              e.preventDefault();

              const targetElement = document.querySelector(targetId);
              if (targetElement) {
                  targetElement.scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                  });
              }
          }
      });
  });

  const pageTopButton = document.getElementById('js-gPageTop_button');
  pageTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}
